import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from 'src/shared/material/material.module';
import { CommonModule } from '@angular/common';
import { DocumentListComponent } from './document-list/document-list.component';
import { AddDocumentComponent } from './add-document/add-document.component';
import { AddDocumentDialogComponent } from './add-document-dialog/add-document-dialog.component';
import { AlertsModule } from '../alerts/alerts.module';
import { EditDocumentDialogComponent } from './edit-document-dialog/edit-document-dialog.component';
import { EditDocumentComponent } from './edit-document/edit-document.component';
import { AddDocumentDragAndDropDialogComponent } from './add-document-dnd-dialog/add-document-dnd-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
		AlertsModule,
	],
	declarations: [
		DocumentListComponent,
		AddDocumentComponent,
		AddDocumentDialogComponent,
		EditDocumentComponent,
		EditDocumentDialogComponent,
		AddDocumentDragAndDropDialogComponent,
	],
	exports: [DocumentListComponent],
})
export class DocumentsModule {}
